
/**
 * SSE 首次响应超时时间
 */
export const SSE_FIRST_RESPONSE_TIMEOUT = 60 * 1000;

/**
 * SSE 进度超时时间
 */
export const SSE_PROGRESS_TIMEOUT = 60 * 1000;


/**
 * SSE 错误消息 - 首次响应超时
 */
export const SSE_ERROR_MESSAGE_FIRST_RESPONSE_TIMEOUT = 'Timeout: No response received within 60 seconds of connection';

/**
 * SSE 错误消息 - 进度超时
 */
export const SSE_ERROR_MESSAGE_PROGRESS_TIMEOUT = 'Timeout: No progress received within 60 seconds of connection';
